import { AddResidentToUnitQueryArg } from '../types/query-arg';
import { AddResidentToUnitQueryBody } from '../types/query-body';

export const addResidentToUnitQueryBody = ({
  resident: { residentId },
  unitId,
}: AddResidentToUnitQueryArg): AddResidentToUnitQueryBody => ({
  residentId,
  unitId,
});
